import {
  SchoolReportOverall,
  SchoolReportSubTopicWise,
  ReportCompetitions,
  ReportSchoolsByCompetition,
  ReportClasses,
  ClassReportOverall,
  ClassReportSubTopicWise,
  ReportStudents,
  StudentsReportSubTopicWise,
  StudentsReportOverall,
  ReportCompetitionsSubTopic,
  SchoolSubtopicOverallReport,
  ClassSubtopicOverallReport,
  SchoolSubtopicSkillReport,
  ClassSubtopicSkillReport,
  FetchCTQuestion,
} from "../apiClient/endpoints";
import Axios from "../apiClient/instance/Axios";

/**
 *
 * @route list competitions
 */
export const ReportCompetitionsService = () => {
  return Axios.get(ReportCompetitions).then((res) => {
    res.data.map((item) => {
      if (item.marks !== null) {
        item.isReportReady = true;
      } else {
        item.isReportReady = false;
      }
      return item;
    });

    return res;
  });
};

export const ReportCompetitionsSubTopicService = (competitionId) => {
  return Axios.get(
    ReportCompetitionsSubTopic.replace("{competitionId}", competitionId)
  );
};

export const ReportSchools = (competitionId) => {
  return Axios.get(
    ReportSchoolsByCompetition.replace("{competitionId}", competitionId)
  ).then((res) => {
    res.data.map((item) => {
      if (item.rank && item.rank >= 0) {
        item.student_attempts = true;
      } else {
        item.student_attempts = false;
      }
      return item;
    });
    return res;
  });
};

export const OverallSchoolReportService = (competitionId, schoolId) => {
  return Axios.get(
    SchoolReportOverall.replace("{competitionId}", competitionId).replace(
      "{schoolId}",
      schoolId
    )
  );
};

// export const OverallSchoolReportService = (competitionId, schoolId) => {
//   return Axios.get(
//     SchoolReportOverall.replace("{competitionId}", competitionId).replace(
//       "{schoolId}",
//       schoolId
//     )
//   ).then((res) => {
//     res.data = Object.assign(res.data, {
//       proficiency_status: "increase",
//       accuracy_status: "equal",
//       marks_status: "double_decrease",
//     });
//     return res;
//   });
// };

export const SchoolReportSubTopicWiseService = (competitionId, schoolId) => {
  return Axios.get(
    SchoolReportSubTopicWise.replace("{competitionId}", competitionId).replace(
      "{schoolId}",
      schoolId
    )
  );
};

// export const SchoolReportSubTopicWiseService = (competitionId, schoolId) => {
//   return Axios.get(
//     SchoolReportSubTopicWise.replace("{competitionId}", competitionId).replace(
//       "{schoolId}",
//       schoolId
//     )
//   ).then((res) => {
//     res.data.map((item) =>
//       Object.assign(item, {
//         proficiency_status: "double_increase",
//         accuracy_status: "equal",
//         marks_status: "double_decrease",
//       })
//     );
//     return res;
//   });
// };

export const ReportClassesService = (competitionId, schoolId) => {
  return Axios.get(
    ReportClasses.replace("{competitionId}", competitionId).replace(
      "{schoolId}",
      schoolId
    )
  ).then((res) => {
    res.data.map((item) => {
      if (item.rank && item.rank >= 0) {
        item.student_attempts = true;
      } else {
        item.student_attempts = false;
      }
      return item;
    });
    return res;
  });
};

export const OverallClassReportService = (competitionId, classCode) => {
  return Axios.get(
    ClassReportOverall.replace("{competitionId}", competitionId).replace(
      "{classCode}",
      classCode
    )
  );
};

export const ClassReportSubTopicWiseService = (competitionId, classCode) => {
  return Axios.get(
    ClassReportSubTopicWise.replace("{competitionId}", competitionId).replace(
      "{classCode}",
      classCode
    )
  );
};

export const ReportStudentsService = (competitionId, classCode) => {
  return Axios.get(
    ReportStudents.replace("{competitionId}", competitionId).replace(
      "{classCode}",
      classCode
    )
  ).then((res) => {
    res.data.map((item) => {
      if (item.rank && item.rank >= 0) {
        item.is_attempted = true;
      } else {
        item.is_attempted = false;
      }
      return item;
    });
    return res;
  });
};

export const OverallStudentReportService = (
  competitionId,
  classCode,
  studentId
) => {
  return Axios.get(
    StudentsReportOverall.replace("{competitionId}", competitionId)
      .replace("{classCode}", classCode)
      .replace("{studentId}", studentId)
  );
};

export const StudentReportSubTopicWiseService = (
  competitionId,
  classCode,
  studentId
) => {
  return Axios.get(
    StudentsReportSubTopicWise.replace("{competitionId}", competitionId)
      .replace("{classCode}", classCode)
      .replace("{studentId}", studentId)
  );
};

export const SchoolSubtopicOverallReportService = (payload) => {
  return Axios.get(
    SchoolSubtopicOverallReport.replace("{schoolId}", payload.schoolId)
      .replace("{nodeId}", payload.nodeId)
      .replace("{limit}", payload.params.limit)
      .replace("{offset}", payload.params.offset)
  );
};


export const ClassSubtopicOverallReportService = (payload) => {
  return Axios.get(
    ClassSubtopicOverallReport.replace("{classId}", payload.classId)
      .replace("{nodeId}", payload.nodeId)
      .replace("{limit}", payload.params.limit)
      .replace("{offset}", payload.params.offset)
  );
};

export const SchoolSubtopicSkillReportService = (payload) => {
  return Axios.get(
    SchoolSubtopicSkillReport.replace("{schoolId}", payload.schoolId)
      .replace("{nodeId}", payload.nodeId)
      .replace("{limit}", payload.params.limit)
      .replace("{offset}", payload.params.offset)
  );
};


export const ClassSubtopicSkillReportService = (payload) => {
  return Axios.get(
    ClassSubtopicSkillReport.replace("{classId}", payload.classId)
      .replace("{nodeId}", payload.nodeId)
      .replace("{limit}", payload.params.limit)
      .replace("{offset}", payload.params.offset)
  );
};

export const FetchCTQuestionService = (payload) => {
  return Axios.get(
    FetchCTQuestion.replace("{ctId}", payload.ctId)
  );
};

export const ResetCompetition = (competitionId, classCode, studentId, start_time, end_time) => {
  return Axios.post(`/competition/${competitionId}/class/${classCode}/reset-attempt/`,{
    start_time: start_time || null,
    end_time: end_time || null,
    user_id: studentId
  })
};

export const DownloadReport = (competitionId, schoolId) => {
  return Axios.get(`/competition/${competitionId}/school/${schoolId}/generate-report/`)
};

